export const ESTADOS = {
  EN_TRAMITE: 'EN_TRAMITE',
  FASE_AMISTOSA: 'FASE_AMISTOSA',
  VALIDADA: 'VALIDADA',
  ENVIADA: 'ENVIADA',
  ENTREGADA: 'ENTREGADA',
  INALCANZABLE: 'INALCANZABLE',
  RECUPERADA: 'RECUPERADA',
  EN_NOTARIA: 'EN_NOTARIA',
  ACTA_PROVISIONAL: 'ACTA_PROVISIONAL',
  ACTA_DEFINITIVA: 'ACTA_DEFINITIVA',
  INCLUIDA: 'INCLUIDA',
  PUBLICADA: 'PUBLICADA',
  SUSPENDIDA: 'SUSPENDIDA',
  CANCELADA: 'CANCELADA',
  EXPIRADA: 'EXPIRADA'
}

export const PRODUCTOS = {
  PRODUCTO_ICIRED_NOTARIAL: 'ICIRED_NOTARIAL'
}

export const STATUS_CODE_KO = "KO"
export const STATUS_CODE_OK = "OK"

export const MASK_IBAN = "ES-99-99999999-99-9999999999"

export const TIPOS_USUARIOS = {
  USUARIO_TIPO_AGENTE: "agente",
  USUARIO_TIPO_ACREEDOR_PARTICULAR: "acreedorParticular",
  USUARIO_TIPO_ACREEDOR_AUTONOMO: "acreedorAutonomo",
  USUARIO_TIPO_ACREEDOR_ENTIDAD: "acreedorEntidad",
  USUARIO_TIPO_DEUDOR_PARTICULAR: "deudorParticular",
  USUARIO_TIPO_DEUDOR_AUTONOMO: "deudorAutonomo",
  USUARIO_TIPO_DEUDOR_ENTIDAD: "deudorEntidad",
  USUARIO_TIPO_NOTARIO: "notario"
}


export const ACCIONES = {
  ACCION_TRAMITAR: "tramitar",
  ACCION_NOTIFICACION_AMISTOSA: "notificacionAmistosa",
  ACCION_VALIDAR: "validar",
  ACCION_CONFIRMAR_ENVIO: "confirmarEnvio",
  ACCION_CONFIRMAR_ENTREGA: "confirmarEntrega",
  ACCION_FALLO_ENVIO: "falloEnvio",
  ACCION_ADJUDICAR_NOTARIO: "adjudicarNotario",
  ACCION_ACTA_PROVISONAL_ENVIADA: "actaProvisionalEnviada",
  ACCION_ACTA_DEFINITIVA_ENVIADA: "actaDefinitivaEnviada",
  ACCION_INCLUIR: "incluir",
  ACCION_PUBLICAR: "publicar",
  ACCION_ORDEN_PAGO_OPERACION: "ordenPagoOperacion",
  ACCION_ORDEN_PAGO_RECLAMACION: "ordenPagoReclamacion",
  ACCION_ORDEN_PAGO_IMPAGO: "ordenPagoImpago",
  ACCION_ORDEN_PAGO_DEUDOR: "ordenPagoDeudor",
  ACCION_SUSPENDER: "suspender",
  ACCION_REACTIVAR: "reactivar",
  ACCION_CANCELAR: "cancelar",
  ACCION_EXPIRAR: "expirar",
  ACCION_ASIGNAR_AGENTE: "asignarAgente",
  ACCION_RECTIFICAR_IMPAGO: "rectificarImpago",
  ACCION_RECTIFICAR_PAGO: "rectificarPago"
}

export const BUSCADORES = {
  BUSCADOR_ICIRED: "BUSCADOR_ICIRED",
  BUSCADOR_EINFORMA: "BUSCADOR_EINFORMA"
}

export const MOTIVOS_CANCELACION = {
  CANCELACION_CLIENTE: "rejected_client"
}

export const TIPO_AVATAR = {
  FEMALE: "female",
  MALE: "male",
  COMPANY: "company",
  MUG: "mug",
  ABSTRACT: "abstract"
}

export const ESTADO_SOLICITUD_FM = {
  SOLICITUD_ESTADO_PENDIENTE: "PENDIENTE",
  SOLICITUD_ESTADO_ACEPTADA: "ACEPTADA",
  SOLICITUD_ESTADO_RECHAZADA: "RECHAZADA",
}

export const TIPO_EMPRESA_PARTICULAR_FM = {
  PARTICULAR: "PARTICULAR",
  EMPRESA: "EMPRESA"
}

export const TIPOS_FICHEROS = {
  CTI_PDF_REQUERIMIENTO: "cti-req",
  CTI_PDF_INCLUSION_REVERSO: "cti-inc-rev",
  CTI_PDF_INCLUSION: "cti-inc",
  LOGALTY_PDF_REQUERIMIENTO: "logalty-req",
  LOGALTY_PDF_INCLUSION_REVERSO: "logalty-inc-rev",
  LOGALTY_PDF_INCLUSION: "logalty-inc",
  NOTARIO_ACTADEFINITIVA: "notario-act-def",
  NOTARIO_ACTAPROVISIONAL: "notario-act-prov",
  RECLAMACION_DOCUMENTOS: "reclamacion-docs",
  RECLAMACION_MENSAJES: "reclamacion-msgs",
  OPERACION_DOCUMENTOS: "operacion-docs",
  CLIENTE_ACREDITACIONES_RELACION_MAYORISTA: "cliente-acre-rel-mayo",
  CLIENTE_ACREDITACIONES_RELACION_PUNTUAL: "cliente-acre-rel-puntual",
  FICH_MOROSIDAD_PDF: "morosidad-pdf",
  CONTRATO_PDF: "contrato-pdf",
  FACTURAS_CLIENTE: "facturas-cliente",
  PAGOS_DOCUMENTOS: "pagos-docs"
}

export const CODIGOS_PROMOCIONALES = {
  EINFORMA: "einformaweb",
  ACERINOX: "acerinoxweb"
}

export const OUTER_URLS = {
  CONDICIONES_GENERALES_URL: "https://iciredimpagados.com/condiciones-generales",
  POLITICA_PRIVACIDAD_URL: "https://iciredimpagados.com/politica-de-privacidad"
}

export const MAPPING_ID_LEGAL_TIPO_SOCIEDAD = {
  'A': 'anonima_society',
  'B': 'limited_liability_society',
  'C': 'collective_society',
  'D': 'comaditaria_society',
  'E': 'good_community',
  'F': 'cooperative_society',
  'G': 'association',
  'H': 'owner_community',
  'J': 'civil_society',
  'N': 'non_resident_entity',
  'P': 'local_corporation',
  'Q': 'public_organism',
  'R': 'congregations',
  'S': 'state_administration',
  'U': 'temporal_union_enterprise',
  'V': 'other_types',
  'W': 'foreign_residents'
};



export const TIPO_ESTADO_ENVIOS = {
  TIPO_ENVIO_NOTIFICACION: "notification",
  TIPO_ENVIO_PUBLICACION: "published",
  TIPO_ENVIO_ACTA_PROVISIONAL: "in_provisional",
  TIPO_ENVIO_ACTA_DEFINITIVA: "in_definitive"
}

export const ORIGEN_BOTONERA_RECLAMACIONES = {
  RECLAMACION: "reclamacion",
  IMPAGO: "impago"
}

export const CLASS_COLLAPSED_ALL = "p-row-toggler-icon pi pi-fw p-clickable pi-chevron-right";
export const CLASS_EXPANDED_ALL = "p-row-toggler-icon pi pi-fw p-clickable pi-chevron-down";

export const TIPOS_SERVICIOS_PRODUCTO = {
  CONSUMO: "CONSUMO",
  A_EXITO: "A_EXITO",
  PREPAGO: "PREPAGO"
}

export const TIPOS_CONTRATOS_INCOMPATIBLES_ALTA_OPERACION = [
  "BUSQUEDA_FICHERO_MOROSIDAD"
]

export const PLATAFORMA = "icired";

export const TIPOS_SERVICIO = {
  RECLAMACION: "reclamacion",
  CONSULTA: "consulta"
}

export const MAX_FILE_SIZE_MB = 5;
export const MAX_FILE_SIZE_BYTES = 1024 * 1024 * MAX_FILE_SIZE_MB;

export const TIPOS_BONO = {
  COMBINADO: "COMBINADO",
  PROMOCION: "PROMOCION"
}

export const TIPOS_PRODUCTOS_TIPO_SERVICIO = {
  CONSULTA: "consulta",
  INCLUSION: "inclusion",
  VIGILANCIA: "vigilancia"
}